import { createReducer, on } from '@ngrx/store';
import { AppState, initialState } from '@store/app/app.state';
import * as appAction from '@store/app/app.actions';

export const AppStateReducer = createReducer(
  initialState,

  // ERROR
  on(appAction.updateError,               (state: AppState, { error }) =>                ({ ...state, error: error, })),
  // BOOLEANOS
  on(appAction.updateReturnHome,          (state: AppState, { returnHome }) =>          ({ ...state, returnHome: returnHome, })),
  on(appAction.updateLoginInProcess,      (state: AppState, { loginInProcess }) =>      ({ ...state, loginInProcess: loginInProcess, })),
  on(appAction.updateVerifyTotpInProcess, (state: AppState, { verifyTotpInProcess }) => ({ ...state, verifyTotpInProcess: verifyTotpInProcess, })),
  on(appAction.updateShowClientsRequests, (state: AppState, { showClientsRequests }) => ({ ...state, showClientsRequests: showClientsRequests, })),
);  